import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: process.env['NEXT_PUBLIC_GA'] || '',
};
const init = () => TagManager.initialize(tagManagerArgs);
const sendGAEvent = (optionsOrName: string) =>
  TagManager.initialize({
    ...tagManagerArgs,
    events: {
      sendUserInfo: optionsOrName,
    },
  });
const useGoogleAnalytics = () => {
  useEffect(() => {
    init();
  }, []);
};
export { useGoogleAnalytics, sendGAEvent };
